function Toast(element) {
    const toast = new Bootstrap.Toast(element);

    function resetClasses(event) {
        event.target.className = event.target.className.split(' ').filter(className => {
            return !className.startsWith('bg-');
        }).join(' ');
    }

    function success(message) {
        element.querySelector('.toast-body').innerHTML = message;
        element.classList.add('bg-success');
        toast.show();
    }

    function error(message) {
        element.querySelector('.toast-body').innerHTML = message;
        element.classList.add('bg-danger');
        toast.show();
    }


    element.addEventListener('hidden.bs.toast', resetClasses);

    return {
        success,
        error
    }
}

window.Toast = Toast;
